export const siteInfo = {
  name: '韩漫之家',
  tagline: '免费韩漫大全 · 好看韩国漫画在线观看',
  description: '韩漫之家致力于为中文读者提供最全、最新、最优质的韩国漫画资源。我们聚合海量高品质韩国漫画，涵盖恋爱、动作、奇幻、搞笑、悬疑、治愈、剧情等多种分类，每日更新，让您畅享漫画阅读的乐趣。',
  url: 'https://yangyijixie.cn',
  email: 'contact@hanmanzhijia.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京SOHO T2-A座 15层',
  foundingYear: 2018,
  stats: {
    totalComics: 12800,
    dailyVisitors: 520000,
    monthlyUpdates: 3600,
    userRating: 4.8,
  },
  socialLinks: {
    weibo: 'https://weibo.com/hanmanzhijia',
    wechat: 'hanmanzhijia',
    bilibili: 'https://space.bilibili.com/hanmanzhijia',
  },
};